import Vue from 'vue'
import axios from 'axios'
import { storeToRefs } from 'pinia'
import useAuthStore from '@/store/auth'

const axiosEmail = axios.create({
  baseURL: process.env.VUE_APP_EMAIL,
  // baseURL: 'https://localhost:7137/api/',
})

axiosEmail.interceptors.request.use(
  config => {
    if (config.headers.Authorization) {
      return config
    }

    const { accessToken } = storeToRefs(useAuthStore())

    if (!accessToken.value) return config
    return { ...config, headers: { Authorization: `Bearer ${accessToken.value}` } }
  },
  error => Promise.reject(error),
)

axiosEmail.interceptors.response.use(
  response => {
    if (!['post', 'put', 'delete'].includes(response.config.method)) return response

    const AUTH_TESTAR_CONFIG_EMAIL_ENDPOINTS = ['auth/testar-configuracoes-imap-smtp', 'auth/testar-configuracoes-microsoft']
    if (AUTH_TESTAR_CONFIG_EMAIL_ENDPOINTS.includes(response.config.url)) {
      return response
    }

    Vue.$toast.clear()
    Vue.$toast.success(response.data.message)

    return response
  },
  async error => {
    const { status, data: { message } } = error.response

    if (status === 400 || status === 422) {
      Vue.$toast.warning(message)
    } else if (status === 500) {
      Vue.$toast.error(message)
    }

    return Promise.reject(error)
  },
)
export default axiosEmail
